
if (!Array.prototype.entries) {
    // eslint-disable-next-line
    Array.prototype.entries = function() {
        var k = 0, o = this;
        return {
           next: function(){
            return k < o.length ?
                {value: [k,o[k++]], done: false} :
                {done: true};
           }
        };
    };
 }

 if (!Array.prototype.keys) {
    // eslint-disable-next-line
    Array.prototype.keys = function() {
        var k = 0, o = this;
        return {
           next: function(){
            return k < o.length ?
                {value: k++, done: false} :
                {done: true};
           }
        };
    };
 }

 if (!Array.prototype.values) {
    // eslint-disable-next-line
    Array.prototype.values = function() {
        var k, a = [], nextIndex = 0, ary = this;
        k = ary.length;
        while (k > 0) a[--k] = ary[k];
        a.next = function(){
            return nextIndex < ary.length ?
                {value: ary[nextIndex++], done: false} :
                {done: true};
        };
    return a;
    };
 }

 if (!Array.prototype.includes) {
    // eslint-disable-next-line
    Array.prototype.includes = function(searchElement, fromIndex) {
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }
        var o = Object(this);
        var len = o.length >>> 0;
        if (len === 0) {
            return false;
        }
        var n = fromIndex | 0;
        var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
        while (k < len) {
            if (o[k] === searchElement) {
                return true;
            }
            k++;
        }
        return false;
    }
}
